import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  FormLabel,
  HStack,
  Input,
  Stack,
  Text,
  Textarea,
  VStack,
} from "@chakra-ui/react";
import MainInput from "../../../../components/Form/input";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { openQuestionsListModel } from "../../../../modules/admin-modules/models/Actions";
import { getAllTagsRequest } from "../../../../modules/admin-modules/tags/Actions";
import {
  adminSelectStyles,
  withAdminSelectMenuPortal,
} from "../../../../components/Models/admin-modal-theme";

const StepTwo = ({
  watchTotalQustions,
  watchSubType,
  watchQuestionWay,
  data,
  setValue,
  register,
  errors,
  isFormOne,
  watchChapters,
  watchExamTags,
  isAdd,
  watchType,
}) => {
  const dispatch = useDispatch();
  const [menuPortalTarget, setMenuPortalTarget] = useState(null);

  useEffect(() => {
    setMenuPortalTarget(document.body);
  }, []);

  const selectStyles = useMemo(
    () => withAdminSelectMenuPortal(adminSelectStyles()),
    []
  );
  const selectPortalProps = {
    menuPortalTarget,
    menuPosition: "fixed",
    maxMenuHeight: 240,
  };

  const [fieldsCount, setFieldsCount] = useState(1);
  const [tagFieldsCount, setTagFieldsCount] = useState(1);
  const [selectedGroupOptions, setSelectedGroupOptions] = useState([]);

  const chapters = useSelector((state) => state.chapters.chapters);
  const tags = useSelector((state) => state.adminTags.tags);

  useEffect(() => {
    if (tags?.length === 0) dispatch(getAllTagsRequest());
  }, [dispatch, tags?.length]);

  useEffect(() => {
    if (watchSubType == 4) {
      setValue("chapters[1][no_of_questions]", 0);
    }
  }, [watchSubType, setValue]);

  useEffect(() => {
    const chapterCount = data?.chapters?.length;
    setFieldsCount(!isAdd && chapterCount > 0 ? chapterCount : 1);

    const tagCount = data?.exam_tags?.length;
    setTagFieldsCount(!isAdd && tagCount > 0 ? tagCount : 1);

    const groupOpts = (data?.groups || []).map((val) => ({
      label: val?.name,
      value: val?.id,
    }));
    setSelectedGroupOptions(groupOpts);
    if (!isAdd && data?.id) {
      setValue(
        "groups",
        (data?.groups || []).map((g) => g?.id ?? g)
      );
    }
  }, [data?.id, isAdd, setValue]);

  const groups = useSelector((state) => state.groups.groups);
  const performanceGroups = useSelector(
    (state) => state.groups.performanceGroups
  );

  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const performanceGroupsOptions =
    performanceGroups?.length > 0
      ? performanceGroups?.map((data) => {
        return { value: data.id, label: data.name };
      })
      : [];

  const chaptersOptions = chapters?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const tagsOptions = tags?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const chapterQuestionCount = (ch) =>
    ch?.no_of_questions ?? ch?.pivot?.no_of_questions ?? 0;

  const chaptersForTotal = Array.isArray(watchChapters)
    ? watchChapters
    : watchChapters && typeof watchChapters === "object"
      ? Object.values(watchChapters)
      : [];

  const totalSelectedQuestions = chaptersForTotal.reduce((accumulator, value) => {
    if (!value) return Number(accumulator);
    return Number(accumulator) + Number(chapterQuestionCount(value));
  }, 0);

  const examTagsForTotal = Array.isArray(watchExamTags)
    ? watchExamTags
    : watchExamTags && typeof watchExamTags === "object"
      ? Object.values(watchExamTags)
      : [];

  const totalSelectedTagQuestions = examTagsForTotal.reduce(
    (accumulator, value) => {
      if (!value) return Number(accumulator);
      return (
        Number(accumulator) +
        Number(value?.question_number ?? value?.no_of_questions ?? 0)
      );
    },
    0
  );
  return (
    <VStack
      display={!isFormOne ? "flex" : "none"}
      dir="ltr"
      w="100%"
      flexWrap="wrap"
      justifyContent="space-between"
      spacing="50px"
      overflow="visible"
    >
      <HStack w="100%" gap={5} mt={4}>
        <Box w="45%">
          <FormLabel>Groups:</FormLabel>
          <Select
            options={groupsOptions}
            isMulti={true}
            onChange={(selected) => {
              const options = selected || [];
              setSelectedGroupOptions(options);
              setValue(
                "groups",
                options.map((val) => val.value)
              );
            }}
            styles={selectStyles}
            placeholder="Select groups"
            value={selectedGroupOptions}
            {...selectPortalProps}
          />
        </Box>
        <Box w="45%">
          {performanceGroupsOptions?.map((data, index) => {
            return (
              <>
                <FormLabel>{data?.label}</FormLabel>
                <MainInput
                  label=""
                  defaultValues={data.question_number}
                  error={errors?.question_number?.message}
                  placeholder="Enter minimum target"
                  register={register}
                  name="question_number"
                  required={false}
                  onChange={(e) => {
                    setValue(
                      `chapters[${index + 1}][min_target]`,
                      e?.target?.value
                    );
                    setValue(
                      `chapters[${index + 1}][performance_gp_id]`,
                      data?.id
                    );
                  }}
                />
              </>
            );
          })}
        </Box>
      </HStack>
      <Box w="100%">
        <FormLabel>Question selection:</FormLabel>

        <Stack
          direction="row"
          role="group"
          aria-labelledby="my-radio-group"
          spacing="30px"
        >
          <label>
            <input
              {...register("random", { required: "This field is required" })}
              type="radio"
              value="0"
              defaultChecked={data?.random == 0 ? true : false}
            />
            Teacher selects questions
          </label>
          <label>
            <input
              {...register("random", { required: "This field is required" })}
              type="radio"
              value="1"
              defaultChecked={data?.random == 1 ? true : false}
            />
            Random questions from question bank
          </label>
          <Text color="red">{errors?.random?.message}</Text>
        </Stack>
      </Box>
      <HStack w="100%" alignItems="flex-start">
        <VStack w="50%" alignItems="flex-start">
          <FormLabel>Scope:</FormLabel>
          <Stack
            direction="row"
            role="group"
            aria-labelledby="my-radio-group"
            spacing="30px"
          >
            <label>
              <input
                {...register("sub_type", {
                  required: "This field is required",
                })}
                type="radio"
                value="1"
                defaultChecked={data?.sub_type == 1 ? true : false}
              />
              Single chapter
            </label>
            <label>
              <input
                {...register("sub_type", {
                  required: "This field is required",
                })}
                type="radio"
                value="2"
                disabled={watchQuestionWay == 0 ? true : false}
                defaultChecked={data?.sub_type == 2 ? true : false}
              />
              Multiple chapters (comprehensive)
            </label>
            <label>
              <input
                {...register("sub_type", {
                  required: "This field is required",
                })}
                type="radio"
                value="4"
                disabled={watchQuestionWay == 0 ? true : false}
                defaultChecked={data?.sub_type == 4 ? true : false}
              />
              Exam from tags
            </label>
          </Stack>
        </VStack>
        <Box w="50%">
          <FormLabel w="30%">Number of questions:</FormLabel>
          <MainInput
            key={`question-number-${data?.id ?? "new"}-${data?.question_number ?? ""}`}
            label=""
            defaultValues={data?.question_number}
            error={errors?.question_number?.message}
            placeholder="Enter number of questions"
            register={register}
            name="question_number"
            required={false}
          />
        </Box>
        {!isAdd && watchQuestionWay == 0 && (
          <Button w="30%" onClick={() => dispatch(openQuestionsListModel())}>
            Choose questions
          </Button>
        )}
      </HStack>

      {watchSubType == 1 && (
        <HStack w="100%" gap="30px" alignItems="flex-end">
          <Box w="70%">
            <FormLabel>Chapter:</FormLabel>
            <Select
              options={chaptersOptions}
              isMulti={false}
              onChange={(selected) => {
                setValue("chapters[1][chapter_id]", selected?.value);
                setValue("chapters[1][no_of_questions]", watchTotalQustions);
              }}
              styles={selectStyles}
              placeholder="Select chapter"
              defaultValue={
                data?.chapters?.[0]
                  ? {
                      label: data.chapters[0]?.name,
                      value: data.chapters[0]?.id,
                    }
                  : undefined
              }
              {...selectPortalProps}
            />
          </Box>
        </HStack>
      )}
      {watchSubType == 2 && watchTotalQustions && (
        <HStack w="100%" alignItems="flex-start">
          <VStack w="70%" alignItems="flex-start">
            <FormLabel>Chapters:</FormLabel>

            {[...Array(fieldsCount)].map((val, index) => {
              const chapter = data?.chapters?.[index];
              return (
                <HStack w="100%" spacing="40px" key={`chapter-row-${index}`}>
                  <Box w="45%">
                    <Select
                      options={chaptersOptions}
                      isMulti={false}
                      onChange={(selected) => {
                        setValue(
                          `chapters[${index + 1}][chapter_id]`,
                          selected?.value
                        );
                      }}
                      styles={selectStyles}
                      placeholder="Select chapter"
                      defaultValue={
                        chapter
                          ? { label: chapter?.name, value: chapter?.id }
                          : undefined
                      }
                      {...selectPortalProps}
                    />
                  </Box>

                  <HStack w="45%">
                    <FormLabel w="60%">Questions count:</FormLabel>
                    <Input
                      size="md"
                      defaultValue={
                        chapter
                          ? chapterQuestionCount(chapter)
                          : ""
                      }
                      onChange={(e) => {
                        setValue(
                          `chapters[${index + 1}][no_of_questions]`,
                          e.target.value
                        );
                      }}
                      placeholder="Enter questions count"
                      name={`chapters_${index + 1}_no_of_questions`}
                    />
                  </HStack>
                </HStack>
              );
            })}
          </VStack>
          <Button
            w="30%"
            onClick={() => setFieldsCount((s) => s + 1)}
            isDisabled={
              totalSelectedQuestions >= watchTotalQustions ? true : false
            }
          >
            Add another chapter
          </Button>
        </HStack>
      )}
      {watchSubType == 4 && watchTotalQustions && (
        <VStack w="100%" alignItems="flex-start" spacing="30px">
          <Box w="70%">
            <FormLabel>Chapter:</FormLabel>
            <Select
              options={chaptersOptions}
              isMulti={false}
              onChange={(data) => {
                setValue("chapters[1][chapter_id]", data?.value);
                setValue("chapters[1][no_of_questions]", 0);
              }}
              styles={selectStyles}
              placeholder="Select chapter"
              defaultValue={
                data?.chapters?.[0]
                  ? {
                      label:
                        data.chapters[0]?.name ??
                        data.chapters[0]?.chapter?.name,
                      value:
                        data.chapters[0]?.id ?? data.chapters[0]?.chapter_id,
                    }
                  : undefined
              }
              {...selectPortalProps}
            />
          </Box>
          <HStack w="100%" alignItems="flex-start">
            <VStack w="70%" alignItems="flex-start">
              <FormLabel>Tags:</FormLabel>

            {[...Array(tagFieldsCount)].map((val, index) => {
              const examTag =
                data?.exam_tags?.[index] ?? data?.exam_tags?.[index + 1];
              return (
                <HStack w="100%" spacing="40px" key={index}>
                  <Box w="45%">
                    <Select
                      options={tagsOptions}
                      isMulti={false}
                      onChange={(data) => {
                        setValue(
                          `exam_tags[${index + 1}][question_tag_id]`,
                          data?.value
                        );
                      }}
                      styles={selectStyles}
                      placeholder="Select tag"
                      defaultValue={
                        examTag
                          ? {
                              label: examTag?.name ?? examTag?.tag?.name,
                              value:
                                examTag?.question_tag_id ??
                                examTag?.tag_id ??
                                examTag?.id,
                            }
                          : undefined
                      }
                      {...selectPortalProps}
                    />
                  </Box>

                  <HStack w="45%">
                    <FormLabel w="60%">Questions count:</FormLabel>
                    <Input
                      size="md"
                      defaultValue={
                        examTag?.question_number ?? examTag?.no_of_questions
                      }
                      onChange={(e) => {
                        setValue(
                          `exam_tags[${index + 1}][question_number]`,
                          e.target.value
                        );
                      }}
                      placeholder="Enter questions count"
                      name="tag_question_number"
                    />
                  </HStack>
                </HStack>
              );
            })}
          </VStack>
          <Button
            w="30%"
            onClick={() => setTagFieldsCount((s) => s + 1)}
            isDisabled={
              totalSelectedTagQuestions >= watchTotalQustions ? true : false
            }
          >
            Add another tag
          </Button>
        </HStack>
        </VStack>
      )}
    </VStack>
  );
};

export default StepTwo;
